// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__XS0Jy","title":"header_title__34DMw"};